<template>
  <loading-notification
    v-if="!item"
    message="De content wordt geladen..."
  ></loading-notification>

  <div v-else-if="item">
    <template v-if="canEdit">
      <div class="columns">
        <div class="column editorWrapper">
          <tip-tap-editor :initial-content="item.text && item.text.length ? item.text : '<p></p>'" @update:content="update"></tip-tap-editor>
        </div>
      </div>

      <div class="columns">
        <div class="column is-one-quarter">
          <save-buttons
            @save="save()"
            :status="status"
            :noCancel="true"
          ></save-buttons>
        </div>

        <div class="column">
          <p class="wrapped notification is-dark">
            <strong>Embed code</strong><br>

            <textarea
              class="textarea"
              rows="4"
              disabled="disabled"
              v-model="embedCode"
            ></textarea>
          </p>
        </div>
      </div>
    </template>

    <div
      v-else
      id="contentWrapper"
      class="ck-content"
      v-html="transformed(item.text)"
    ></div>

    <template v-if="showLastLevelToggleButton">
      <div class="columns">
        <div class="column">
          <button
            class="button is-pulled-right"
            @click="toggleItems"
          >
            {{ showItems ? 'Verberg items' : 'Toon items' }}
          </button>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <ul v-show="showItems">
            <li
              v-for="child in children"
              :key="child.id"
            >
              {{ child.parsed }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import TipTapEditor from "@/components/modules/TipTapEditor.vue";
import SaveButtons from '@/components/modules/SaveButtons'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  props: {
    path: {
      type: Array,
      required: true
    },

    isGeneralText: {
      type: Boolean,
      default: false
    }
  },

  mixins: [
    authMixin
  ],

  components: {
    TipTapEditor,
    SaveButtons,
    LoadingNotification
  },

  data () {
    return {
      content: '',
      children: [],
      showItems: false
    }
  },

  computed: {
    ...mapGetters({
      page: 'pages/page',
      mode: 'pages/mode',
      item: 'pageItems/item',
      status: 'pageItems/status',
      account: 'account/account',
      removables: 'pageItems/removables',
      isAuthorised: 'users/isAuthorised'
    }),

    identifier () {
      return this.path.slice(0, this.path.length).join(':')
    },

    canEdit () {
      return (this.isAdmin(this.account) || this.inScope(this.account, 14)) && this.isAuthorised
    },

    embedCode () {
      if (this.item) {
        return '[@' + this.item.embedCode + ']'
      }

      return null
    },

    embedCodeColumnId () {
      return process.env.NODE_ENV === 'production' ? 231 : 2
    },

    showLastLevelToggleButton () {
      return this.page.columns[this.page.columns.length - 1] !== this.embedCodeColumnId
    }
  },

  created () {
    if (!this.isGeneralText) {
      this.fetchChildren()

      const path = `${this.identifier}-${this.page.id}:${this.page.bundle.id}`

      this.$store.dispatch('pageItems/load', { path: path, edit: this.canEdit })
    }
  },

  watch: {
    params () {
      this.showItems = false
    }
  },

  methods: {
    toggleItems () {
      this.showItems = !this.showItems
    },

    save () {
      if (this.item.id) {
        this.$store.dispatch('pageItems/update', this.item)
      } else {
        this.$store.dispatch('pageItems/create', {
          text: this.content,
          path: this.identifier,
          pageId: this.page.id,
          bundleId: this.page.bundle.id
        })
      }

      if (this.removables.length > 0) {
        this.$store.dispatch('pageItems/remove', this.removables)
      }
    },

    update (payload) {
      if (this.item.id) {
        this.$store.commit('pageItems/SET_ITEM_TEXT', payload)
      } else {
        this.content = payload
      }
    },

    transformed (payload) {
      const search = /<figure class="media"><oembed url="(.*)"><\/oembed><\/figure>/
      const replace = `<div class="cw-container"><iframe class="cw-content" style="width: 100%; height: 100vh;" src="$1"></iframe></div>`

      const replacement = payload.replace(search, replace)

      return replacement.replace(/[\u200B-\u200D\uFEFF]/g, '')
    },

    fetchChildren () {
      let self = this

      let params = {
        hasAccess: this.canEdit,
        path: this.path,
        mode: this.mode,
        childColumnId: this.page.columns[this.page.columns.length - 1],
        pageId: this.page.id,
        bundleId: (this.auth) ? this.$route.params.bundleId : this.page.bundle.id
      }

      this.$store.dispatch('pages/fetchChildren',
        params
      ).then(
        (res) => {
          self.children = res.children
        }
      )
    }
  }
}
</script>

<style scoped>
  .wrapped {
    word-wrap: break-word;
  }

  .editorWrapper {
    width: 100%;
  }

  textarea {
    width: 100%;
    padding: 15px;
    border-radius: 5px;
  }

  .cw-container {
    position: relative;
    width: 100%;
    height: auto;
    padding-bottom: 56.25%;
  }

  .cw-content {
    border: 0;
  }
</style>

<style>
.ck-content table th,
.ck-content table td {
  border: 1px solid #aaa !important;
  padding: 8px 12px !important;
}
</style>